/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import proptypes from 'prop-types';
const { func, string } = proptypes;
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { ExperienceContext, useStore, useConfigService } from '@thd-nucleus/experience-context';
import { FBTProvider } from './contexts/FBTContext';
import { FBTProviderTnt } from './contexts/FBTContextTnt';
import { fbtRecsDataModel } from './dataModel';
import { RecsFBT } from './RecsFBT/RecsFBT.component';
import { RecsFBTTnt } from './RecsFBT/RecsFBTTnt.component';
import { FBTPlaceholder } from './FBTPlaceholder.component';
import './thd-recs-fbt.module.scss';
import {
  DtsTntVariables,
  UseRecsCxtAndProps,
  checkIfDtsEnabled,
  isNotDts,
  isDtsApiMatch,
  checkIfTntEnabled,
  parseTntEventData
} from './helpers/tnt-variables';

const FrequentlyBoughtTogether = (props) => {
  const {
    itemId, onLoadDynamicRecs, apiName, name
  } = props;
  const [mounted, setMounted] = useState(false);
  const abcRecsTestEnable = useConfigService('fs:isABCRecsTestEnable');
  const initialHideFBT = useConfigService('fs:hideFBT');
  const [tntData, setTntData] = useState(null);
  const [fbtTnTFS, setFbtTnTFS] = useState(null);
  const [showAsFallback, setShowAsFallback] = useState(false);
  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const storeInfo = useStore();

  useEffect(() => {
    setMounted(true);
    if (abcRecsTestEnable && typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.on('recs.tnt', (data) => {
        let tntObj = {};
        const output = data?.output;
        if (output?.currentAPI === apiName) {
          if (output?.isDts) {
            tntObj.isDts = output?.isDts;
            tntObj.isTNT = data?.eventName === 'tnt';
            tntObj.schemaName = output?.dtsModel?.model;
            tntObj.dtsModelVariables = output?.dtsModel;
            tntObj.tntTitle = output?.dtsModel?.tntTitle;
            tntObj.tntTitleCustomerType = output?.dtsModel?.tntTitleCustomerType;
            setTntData(tntObj);
          } else {
            tntObj.isDts = output?.isDts;
            tntObj.isTNT = data?.eventName === 'tnt';
            tntObj.schemaName = output?.recsModel?.testAPI;
            tntObj.recsModelVariables = output?.recsModel;
            tntObj.tntTitle = output?.recsModel?.tntTitle;
            tntObj.tntTitleCustomerType = output?.recsModel?.tntTitleCustomerType;
            setTntData(tntObj);
          }
        }
      });
    }
    
    if ( typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.on('recsFS.tnt', (eventData) => {
        const parsedValues = parseTntEventData(eventData);
        if (Object.keys(parsedValues).length > 0) {
          setFbtTnTFS(parsedValues);
        }
      });

      LIFE_CYCLE_EVENT_BUS.lifeCycle.on('bbt.fallback', (fallbackData) => {
        const fallbackDataOutput = fallbackData?.output;
        if(fallbackDataOutput?.itemId !== null && fallbackDataOutput?.itemId !== undefined){
          setShowAsFallback(true);
        }
      });
    }
  }, []);

  const hideFBT = fbtTnTFS?.hideFBT ?? initialHideFBT;

  if (hideFBT && !showAsFallback) return null;

  if (mounted) {
    const queryProps = {};
    if (checkIfDtsEnabled(abcRecsTestEnable, tntData)) {
      const { qName, dtsopts, dtsAnchor } = DtsTntVariables(tntData?.dtsModelVariables, props, storeInfo, channel, isConsumerApp);
      queryProps.qName = qName;
      queryProps.vars = dtsopts;
      queryProps.anchor = dtsAnchor;
    } else if (checkIfTntEnabled(abcRecsTestEnable, tntData) && isNotDts(tntData)) {
      const { qName, recsOpts, recsAnchor } = UseRecsCxtAndProps(tntData?.recsModelVariables, props, storeInfo, channel, isConsumerApp);
      queryProps.qName = qName;
      queryProps.vars = recsOpts;
      queryProps.anchor = recsAnchor;
    }
    return (
      (checkIfDtsEnabled(abcRecsTestEnable, tntData) || isNotDts(tntData)) ? (
        <FBTProviderTnt
          itemId={itemId}
          apiName={apiName}
          onLoadDynamicRecs={onLoadDynamicRecs}
          tntData={tntData}
          queryProps={queryProps}
          fusionContainerSlotName={name}
        >
          <RecsFBTTnt />
        </FBTProviderTnt>
      ) : (
        <FBTProvider
          itemId={itemId}
          apiName={apiName}
          onLoadDynamicRecs={onLoadDynamicRecs}
          tntData={tntData}
          queryProps={queryProps}
          fusionContainerSlotName={name}
        >
          <RecsFBT />
        </FBTProvider>
      )

    );
  }
  return null;
};

FrequentlyBoughtTogether.displayName = 'ThdRecsFbt';

const propTypes = {
  itemId: string.isRequired,
  apiName: string,
  onLoadDynamicRecs: func,
  name: string
};
const defaultProps = {
  onLoadDynamicRecs: null,
  apiName: '',
  name: ''
};
FrequentlyBoughtTogether.propTypes = propTypes;
FrequentlyBoughtTogether.defaultProps = defaultProps;
FrequentlyBoughtTogether.dataModel = fbtRecsDataModel;
const HydratedFBT = withHydrator({
  delay: 1500,
  id: 'product-section-fbt',
  placeholder: (<FBTPlaceholder />),
  preserveCtxVal: 'clientStore',
  scrollBuffer: 0
}, FrequentlyBoughtTogether);

const ThdRecsFbt = withErrorBoundary(HydratedFBT);

ThdRecsFbt.propTypes = propTypes;
ThdRecsFbt.defaultProps = defaultProps;
// dataModels should be defined on the component and extended up, not at a global component level
ThdRecsFbt.dataModel = fbtRecsDataModel;
ThdRecsFbt.displayName = FrequentlyBoughtTogether.displayName;

export { ThdRecsFbt };
